// Media published to Facebook, Instagram or LinkedIn is served from signed urls that carry their
// own expiry, so it is read straight from the url rather than by fetching it. Meta spells it `oe`
// in hex seconds; LinkedIn spells it `e` in decimal milliseconds.
const PLATFORM_MEDIA_HOSTS = ["fbcdn.net", "cdninstagram.com", "licdn.com"];

const EXPIRY_PARAMS: { name: string; radix: number }[] = [
  { name: "oe", radix: 16 },
  { name: "e", radix: 10 }
];

function readExpiryInMillis(params: URLSearchParams): number | undefined {
  for (const { name, radix } of EXPIRY_PARAMS) {
    const raw = params.get(name);
    if (!raw) {
      continue;
    }
    const pattern = radix === 16 ? /^[0-9a-fA-F]+$/ : /^[0-9]+$/;
    if (!pattern.test(raw)) {
      continue;
    }
    return parseInt(raw, radix) * 1000;
  }
  return undefined;
}

function isPlatformMediaHost(hostname: string): boolean {
  return PLATFORM_MEDIA_HOSTS.some(
    host => hostname === host || hostname.endsWith(`.${host}`)
  );
}

export function isExpiredPlatformMedia(
  url: unknown,
  nowInMillis: number = Date.now()
): boolean {
  if (typeof url !== "string") {
    return false;
  }

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }

  if (!isPlatformMediaHost(parsed.hostname)) {
    return false;
  }

  const expiryInMillis = readExpiryInMillis(parsed.searchParams);

  return expiryInMillis !== undefined && expiryInMillis < nowInMillis;
}

export function hasExpiredPlatformMedia(
  attachments: { url?: unknown }[],
  nowInMillis: number = Date.now()
): boolean {
  return attachments.some(attachment =>
    isExpiredPlatformMedia(attachment?.url, nowInMillis)
  );
}
